
import * as Components from "./Lancersnew"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "lancersnew"
}

